import { useMutation } from '@tanstack/react-query';
import httpv2 from 'apis/httpv2';
import { MutationConfig, TransactionTypeDto } from 'types';

interface CreateTransactionTypeOptions {
  data: TransactionTypeDto;
}

export const createTransactionType = ({ data }: CreateTransactionTypeOptions) => {
  return httpv2.post<TransactionTypeDto>('/transaction-types', data);
};

interface UseCreateTransactionTypeOptions {
  mutationConfig?: MutationConfig<typeof createTransactionType>;
}

export const useCreateTransactionType = ({ mutationConfig }: UseCreateTransactionTypeOptions = {}) => {
  const config = mutationConfig || {};

  return useMutation({
    ...config,
    mutationFn: createTransactionType,
  });
};
